import React from 'react';
import { container } from 'tsyringe';
import FilteredDataTable from '@base/ui/components/filteredDataTable';
import { feeStatisticsCols } from './feeStatisticsColumns';
import { IUserService } from '../model/interfaces';
import { RangeValue } from '@ui-kit/components/rangePicker';
import Empty from '@ui-kit/components/empty';
import { ReactComponent as NoFeeStatistics } from '@base/assets/images/no_fee_statistics.svg';
import { t } from '@base/utils/helpers';
import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';

export default function TournamentStatistics() {
  const userService: IUserService = container.resolve('userService');
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  return (
    <FilteredDataTable
      getData={(range?: RangeValue) => userService.getReferalFeeStatistics(range)}
      getTableData={(data) => data.rows}
      columns={feeStatisticsCols}
      rangePickerTitle={t('referral_fees_earned')}
      footer={(data) => (
        <div>
          <div>
            {playersOnlineRepository.me && t('total_fees_for_life', playersOnlineRepository.me.name) + ': '}
            <strong>{data.totalFees}</strong>
          </div>
          <div>
            {t('fees_for_selected_period') + ': '}
            <strong>{data.rows.reduce((acc, cur) => acc + cur.feesInTickets, 0)}</strong> {t('tickets')}
          </div>
        </div>
      )}
      empty={
        <Empty icon={<NoFeeStatistics height="124px" width="144px" />} style={{ margin: '100px' }}>
          {t('no_referred_players')}
        </Empty>
      }
      tableStyle={{ maxHeight: '400px' }}
    />
  );
}
